import React from "react";
import { connect } from "react-redux";
import Upload from "./upload/Upload";
import RecentBatch from "./recent_batch/RecentBatch";
import ClaimsTable from "./claims_table/ClaimsTable";
import {Header,SideNavbar,TokenCheck} from '../index';

import {setProviderInfo} from '../login_page/login.action';
import { bindActionCreators } from "redux";




class SubmitClaimsWrapper extends React.Component {
  // constructor(props){
  //   super(props);
  //   this.state={
  //     tokenCheck:true
  //   }
  // }
  // componentWillMount=()=>{
  //   this.tokenExpiryCheck();
  // }
  render=()=> {
   
    //   if(this.state.tokenCheck===false || localStorage.getItem('authToken') === null){
    //    return <Redirect to="/logout" />
    //  }
    // this.getProviderInfo(localStorage.getItem('authToken'))
      return (
        <div>
          <TokenCheck/>
          <Header />
          <SideNavbar />
          <div className="body-content">
            <div className="page-title">Submit Claims</div>
            <div className="page-subtitle">Subtitle</div>
            <Upload />
            <RecentBatch />
            <ClaimsTable uploaded_claims={this.props.view_claims}  />
          </div>
        </div>
      );
  }

  // tokenExpiryCheck=()=>{
  //   const token = localStorage.getItem('authToken');
  //   console.log("token check req",kinetik_api_url+'/tokenCheck?token='+token);
  //     axios.get(kinetik_api_url+'/tokenCheck?token='+token).then((res)=>{
  //       console.log("res from token Check",res)
  //       if(res.data.status!=='success'){
  //         this.setState({tokenCheck:false})
  //       }
  //     })
  // }
  // getProviderInfo=(authToken)=>{
  //       console.log("authToken",authToken)
  //       const userID = jwtDecode(authToken).user_id;
  //       return new Promise((resolve, reject) => {
  //          axios.get(kinetik_api_url + '/get_boarding_info/' + userID).then(res=>{
  //            console.log("onboarding info res",res)
  //           localStorage.setItem('payers',res.data.result.company_payers);
  //           // parse JSON for companybrokers, companypayers
  //           let processCompanyPayer = res.data.result.company_payers.length !== 0 ?
  //            JSON.parse(res.data.result.company_payers) : [];
  //           let processCompanyBroker = res.data.result.company_brokers.length !== 0 ?
  //            JSON.parse(res.data.result.company_brokers) : [];
  //           res.data.result.company_payers = processCompanyPayer;
  //           res.data.result.company_brokers = processCompanyBroker;
  //           this.props.setProviderInfo(res.data.result);
  //           localStorage.setItem('bill_npi',res.data.result.company_billing_npi)
  //           resolve("done")
  //           }).catch(err=>{
  //           console.log("err from getting onboarding info",err)
  //           resolve(err)
  //           })
  //       })
  // }
}

const mapStateToProps = state => {
  return {
    view_claims: state.submitClaims.view_claims,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setProviderInfo
    },
    dispatch
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(SubmitClaimsWrapper);



// WEBPACK FOOTER //
// ./src/app/submit_claims/Submit_Claims_Wrapper.js